export default {"src":"/_next/static/media/mmxtion.a92aeaf4.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};